import { Injectable, inject } from '@angular/core';

import { catchError, Observable, of } from 'rxjs';
import { Language } from '../services/languages/languages.interfaces';
import { LanguagesService } from '../services/languages/languages.service';

/**
 * Resolver to fetch all languages
 */
@Injectable()
export class LanguagesResolver {
  private readonly languagesService = inject(LanguagesService);

  langs: Language[] = [
    { id: 1, culture: 'NL', name: 'nl', IdName: 'NL' },
    { id: 2, culture: 'FR', name: 'fr', IdName: 'FR' },
    { id: 3, culture: 'EN', name: 'en', IdName: 'EN' },
  ];

  resolve(): Observable<Language[]> {
    return this.languagesService.getLanguages().pipe(
      catchError((err) => {
        //catch error return default langs
        console.error('language service error', err);
        return of(this.langs);
      }),
    );
  }
}
